import { DiscapacidadEmpleadoDetalle } from './DiscapacidadEmpleadoDetalle';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import Avatar from '@mui/material/Avatar';
import moment from 'moment';
import numbro from 'numbro';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PermissionData } from '../../context/Component/PermissionData';
import { selectEmpleadosIsLoading } from '../../redux/Empleados/EmpleadosSlice';

export const EmpleadoPerfil = (props) => {
  // * PERMISOS DEL USUARIO.
  const permisosState = PermissionData();

  const isLoading = useSelector(selectEmpleadosIsLoading);
  const navigate = useNavigate();
  const { empleado } = props;

  return (
    <div className="container">
      {!isLoading && empleado && Object.keys(empleado).length > 0 ? (
        <div className="row ">
          <div className="col-md-2 text-center ">
            <Avatar
              sx={{
                width: 150,
                height: 150,
                marginLeft: 1,
                border: 'solid',
                borderWidth: 1,
                borderColor: '#003876',
                borderRadius: 3,
              }}
              alt={`${empleado?.nombres} ${empleado?.apellidos} `}
              src={empleado.foto}
              variant="square"
            />
            <label className="codigoEmpleado">{empleado?.codigoEmpleado}</label>
          </div>

          <div className="col-md-10">
            <div className="row">
              <div className="col-11">
                <h3 className="text-primary-mem">{`${empleado?.nombres} ${empleado?.apellidos}`}</h3>
              </div>
              <div className="col-1">
                <button
                  type="button"
                  className="btn btn-sm"
                  onClick={() => navigate(`/empleados/editar/${empleado.id}`)}
                  hidden={!permisosState.ROLE_EDITAR_REGISTRO_EMPLEADOS}
                >
                  <BorderColorIcon className="text-primary-mem" />
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="fw-bold">Tipo de Empleado</label>
                  <input className="form-control" readOnly defaultValue={empleado?.tipoEmpleado?.tipo} />
                </div>
              </div>
              <div className="col-4">
                <div className="form-group">
                  <label className="fw-bold">Cargo</label>
                  <input className="form-control" readOnly defaultValue={empleado?.cargoLabel} />
                </div>
              </div>
              <div className="col-4">
                <div className="form-group">
                  <label className="fw-bold">Grupo Ocupacional</label>
                  <input className="form-control" readOnly defaultValue={empleado?.grupoOcupacionalLabel} />
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <label className="fw-bold">Fecha Ingreso</label>
                  <input className="form-control" readOnly defaultValue={moment(empleado?.fechaIngreso).format('DD/MM/yyyy')} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="fw-bold">Cédula</label>
                  <input className="form-control" readOnly defaultValue={empleado?.cedula} />
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <label className="fw-bold">Correo Personal</label>
                  <input className="form-control" readOnly defaultValue={empleado?.emailPersonal} />
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <label className="fw-bold">Fecha Nacimiento</label>
                  <input className="form-control" readOnly defaultValue={moment(empleado?.fechaNacimiento).format('DD/MM/yyyy')} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="fw-bold">Sexo</label>
                  <input className="form-control" readOnly defaultValue={empleado?.sexo} />
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <label className="fw-bold">Estado Civil</label>
                  <input className="form-control" readOnly defaultValue={empleado?.estadoCivil?.nombre} />
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <label className="fw-bold">Celular</label>
                  <input className="form-control" readOnly defaultValue={empleado?.celular} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <div className="form-group">
                  <label className="fw-bold">Área Máxima</label>
                  <input className="form-control" readOnly defaultValue={empleado?.maximaArea?.nombre} />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <label className="fw-bold">Área Padre</label>
                  <input className="form-control" readOnly defaultValue={empleado?.areaOrganizacionalPadre?.nombre} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <div className="form-group">
                  <label className="fw-bold">Área Organizacional</label>
                  <input className="form-control" readOnly defaultValue={empleado?.areaOrganizacionalLabel} />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <label className="fw-bold">Área de Evaluación de Desempeño</label>
                  <input className="form-control" readOnly defaultValue={empleado?.nombredelPadre} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <div className="form-group">
                  <label className="fw-bold">Ubicación</label>
                  <input className="form-control" readOnly defaultValue={empleado?.ubicacionLabel} />
                </div>
              </div>

              <div className="col-6">
                <div className="form-group">
                  <label className="fw-bold">Correo Institucional</label>
                  <input className="form-control" readOnly defaultValue={empleado?.emailInstitucional} />
                </div>
              </div>
            </div>

            <DiscapacidadEmpleadoDetalle empleado={empleado} />
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <label className="fw-bold">Dirección</label>
                  <input className="form-control" readOnly defaultValue={empleado?.direccion} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-4">
                <div className="form-group">
                  <label className="fw-bold">Flota</label>
                  <input className="form-control" readOnly defaultValue={empleado?.flota} />
                </div>
              </div>
              <div className="col-8">
                <div className="form-group">
                  <label className="fw-bold">Nombre del Supervisor</label>
                  <input className="form-control" readOnly defaultValue={empleado?.nombredelSupervisor} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <div className="form-group">
                  <label className="fw-bold">Programa</label>
                  <input type="text" readOnly className="form-control" defaultValue={empleado?.programa?.programa ?? 'Sin especificar'} />
                </div>
              </div>

              <div className="col-6">
                <div className="form-group">
                  <label className="fw-bold">Sueldo</label>
                  <input
                    type="text"
                    readOnly
                    className="form-control"
                    defaultValue={`RD$ ${numbro(empleado?.sueldo ?? 0).format({ thousandSeparated: true })}`}
                  />
                </div>
              </div>
            </div>

            <div className="row mt-4" hidden={empleado?.estado === 1}>
              <div>
                <label className="fw-bold">Desvinculación</label>
              </div>
              <div className="col-4">
                <input readOnly className="form-control" value={moment(empleado?.fechaTermino).format('DD/MM/yyyy')} />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="row text-center">
          <h1 className="text-primary-mem">Empleado no encontrado favor verificar</h1>
        </div>
      )}
    </div>
  );
};

export default EmpleadoPerfil;
